import Colors from "../../../../global/Colors";

export const FilterListConfig = {
  search: {
    fieldName: "search",
    title: "Search",
    filterType: "Search",
    selectedValue: "",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
      clearValueOnDelete: true,
    },
  },
  on_firm: {
    fieldName: "on_firm",
    title: "Filter by Law Firm",
    filterType: "MultiSelectSearch",
    searchTitle: "Law Firm Search",
    showForm: false,
    options: [],
    selectedValue: [],
    checked: [],
    nameKey: "name",
    valueKey: "pk",
    apiUrl: `/api/lawfirm/?`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  on_case: {
    fieldName: "on_case",
    title: "Filter by Case",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Cases",
    showForm: false,
    options: [],
    selectedValue: [],
    checked: [],
    nameKey: "name",
    valueKey: "pk",
    apiUrl: `/api/case/?data-set=search`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.orange[500],
      label: "",
    },
  },
  on_provider: {
    fieldName: "on_provider",
    title: "Filter by Provider",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Providers",
    showForm: false,
    options: [],
    selectedValue: [],
    checked: [],
    nameKey: "name",
    valueKey: "pk",
    apiUrl: `/api/provider/?`,
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.red[500],
      label: "",
    },
  },

  created_at: {
    fieldName: "created_at",
    title: "Date Created",
    filterType: "DateRange",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  due_date: {
    fieldName: "due_date",
    title: "Due Date",
    filterType: "DateRange",
    currentValues: {
      __gte: undefined,
      __lte: undefined,
    },
    permissions: [],
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
};
